export interface Participant {
    id: string;
    name?: string;
    surname1?: string;
    surname2?: string;
    documentNumber?: string;
    dateOfBirth?: string;
    dateOfBirthDate?: Date;
    phoneNumber?: string;
    email?: string;
    province?: string;
    profession?: string;
    employer?: string;
    educationLevel?: string | null;
    educationLevelOther?: string;
    qualificationLevel?: string | null;
    participantSheetAccepted?: boolean;
}

export const EDUCATION_LEVELS = [
    { value: 'noStudies', label: 'Sin estudios' },
    { value: 'primary', label: 'Estudios Primarios, EGB, ESO o equivalente' },
    { value: 'vocationalBachelor', label: 'FPI, FPII, BUP' },
    { value: 'higherTechnician', label: 'Técnico de Grado Medio, Técnico de Grado Superior, Bachiller' },
    { value: 'universityGraduate', label: 'Graduado Universitario' },
    { value: 'technicalDegree', label: 'Arquitecto Técnico, Ingeniero Técnico o Diplomado Universitario' },
    { value: 'higherDegree', label: 'Arquitecto, Ingeniero Superior o Licenciado' },
    { value: 'other', label: 'Otros (especificar)' }
];

export const QUALIFICATION_LEVELS = [
    { value: 'executive', label: 'Directivo' },
    { value: 'technical', label: 'Técnico' },
    { value: 'middleManagement', label: 'Mando Intermedio' },
    { value: 'qualifiedWorker', label: 'Trabajador cualificado' },
    { value: 'lowQualificationWorker', label: 'Trabajador con baja cualificación' }
];
